import type { IconProps } from '../types/IconProps.ts';
export const Cog: IconProps = {
    name: 'Cog',
    children: [
        `<circle cx="12" cy="12" r="8" />`,
        `<path d="M12 2v2M12 20v2M2 12h2M16 12h6M19.07 4.93 18 6M9 15l-4.07 4.07M4.93 4.93 9 9M18 18l1.07 1.07" />`,
        `<circle cx="12" cy="12" r="4" />`,
        `<path d="m15.83 2.76-.39.93M8.17 21.24l.39-.93M21.24 8.17l-.92.39M3.69 15.44l-.93.39M21.24 15.83l-.93-.39M3.69 8.56l-.93-.39M15.83 21.24l-.39-.93M8.56 3.69l-.39-.93" />`,
    ]
};